import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/zustand/auth-store';
import { getHomePath } from '@/utils/helpers';

const PublicRoute = () => {
  const accessToken = useAuth(state => state.accessToken);
  const { pathname } = useLocation();

  // ---- PAGES THAT SHOULD NOT REDIRECT EVEN IF USER HAS TOKEN ----
  const exceptionRoutes = [];

  const isInExceptionPage = exceptionRoutes.includes(pathname);

  if (accessToken && !isInExceptionPage) {
    const homePath = getHomePath();
    // If getHomePath() can't resolve a real home (e.g. it falls back to this
    // same login route), redirecting would just bounce back here forever -
    // render the page instead of looping.
    if (homePath !== pathname) {
      return <Navigate to={homePath} replace />;
    }
  }

  return <Outlet />;
};

export default PublicRoute;
